import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/queryClient";
import { savePreliminary } from "@/api/endpoints/maturity";
import type { MaturityEvaluation } from "@/types/maturity";

export function useSaveMaturityPreliminary(sessionId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (preliminaryResponses: Record<string, boolean>) =>
      savePreliminary(sessionId, preliminaryResponses),
    onMutate: async (newResponses) => {
      await queryClient.cancelQueries({
        queryKey: queryKeys.maturity.evaluation(sessionId),
      });
      const previousData = queryClient.getQueryData<MaturityEvaluation>(
        queryKeys.maturity.evaluation(sessionId)
      );
      queryClient.setQueryData<MaturityEvaluation>(
        queryKeys.maturity.evaluation(sessionId),
        (old) => (old ? { ...old, preliminary_responses: newResponses } : old)
      );
      return { previousData };
    },
    onError: (_err, _newData, context) => {
      if (context?.previousData) {
        queryClient.setQueryData(
          queryKeys.maturity.evaluation(sessionId),
          context.previousData
        );
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.maturity.evaluation(sessionId),
      });
    },
  });
}
